import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=5b1e8dc4"
import script from "./CustomerCare.vue?vue&type=script&lang=js"
export * from "./CustomerCare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports